import { HeartBank } from "../../../managers/HeartBank.ts";
import { analytics, performance } from "../../../firebase.ts";
import { trace, PerformanceTrace } from "firebase/performance";
import { logEvent, setUserProperties } from "firebase/analytics";

import template from "./sw-donate.mjs";
import { render } from "lit-html";
import { SwPopup } from "../sw-popup/sw-popup.ts";
import { SwCode } from "../../sw-header/sw-code/sw-code.ts";

import Strings from "../../../models/Strings.json";
import { LANGUAGE } from "../../global.ts";
const strings: any = Strings;

//TODO: stripe payment link: add custom data

export class SwDonate extends HTMLElement {
    private heartbank: HeartBank = new HeartBank();
    private popup = document.querySelector("sw-popup") as SwPopup;
    private code = document.querySelector("sw-code") as SwCode;

    private componentTrace: PerformanceTrace;
    private cash: HTMLElement;
    private hb: HTMLElement;

    constructor() {
        super();
        this.componentTrace = trace(performance, "component");
        this.componentTrace.putAttribute("view", "sw-donate");
        this.componentTrace.start();
        render(template(null), this);

        this.cash = this.querySelector("#sw-donate-cash")!;
        this.hb = this.querySelector("#sw-donate-hb")!;
    }

    connectedCallback() {
        this.cash.addEventListener("click", () => {
            alert(strings.soon[LANGUAGE]);
            //this.popup.openHB.bind(this, "", false); //TODO: add sw thank link
        });
        this.hb.addEventListener("click", () => {
            this.popup.openHB("", true); //TODO: add sw org link
            //this.code.show("donate");
        });

        this.heartbank.addAuthStateListener3((hero) => {
            render(template(hero), this);
        });

        this.componentTrace.incrementMetric("count", 1);
        this.componentTrace.stop();
    }

    // TODO: ?
    private async handleMessageFromPopup(data: {
        action: string;
        [key: string]: any;
    }) {
        switch (data.action) {
        }
    }
}
